export default {
  /* Global Vocabulary */

  back: "بازگشت",
  cancel: "لغو",
  email: "ایمیل",
  mobile: "موبایل",
  country_of_residence: 'کشور محل سکونت',
  i_did_not_register_yet: "هنوز ثبت‌نام نکرده‌ام",
  i_forgot_my_password: "رمز عبورم را فراموش کرده‌ام",
  login: "ورود",
  logout: "خروج",
  password: "رمز عبور",
  password_confirmation: "تکرار رمز عبور",
  confirm: "تأیید",
  save: "ذخیره",
  unspecified_error: "خطای نامشخص! لطفاً به مدیر سایت گزارش دهید!",
  username: "نام کاربری",
  i_already_have_an_account: "من حساب کاربری دارم",
  create_new_rebit_account: "ایجاد حساب کاربری ربیت",
  please_enter_your_email: "لطفاً ایمیلتان را وارد کنید",
  country_is_required :"درج کشور الزامی است!",
  password_criteria: "رمز عبور باید یک عبارت حداقل <b>۸ کاراکتری</b>، شامل <b>حروف انگلیسی</b> و <b>یک عدد</b> باشد.",
  terms_and_conditions: "قوانین و مقررات",
  privacy_policy: "سیاست حفظ حریم خصوصی",
  terms: "با ایجاد حساب کاربری، شما {terms_and_conditions} و {policy} ربیت را می‌پذیرید و به این شرکت اجازه می‌دهید با شما تماس بگیرد و ارتباطات بازاریابی را با استفاده از اطلاعات تماسی که به ما ارائه کرده‌اید برقرار کند.",

  auth: {
    activation: "فعالسازی",
    activation_code_not_approved: "کد فعالسازی مورد تایید نیست",
    activation_code_sent: "یک کد ۶ رقمی به {email} ارسال شد.",
    activation_code_sent_notify: "ایمیلی حاوی کد فعالسازی به شما ارسال گردید.",
    confirm_activation_code: "تایید کد فعالسازی",
    email_hint: "تنها سرویس gmail پذیرفتنی است",
    enter_the_code_here: "کد را اینجا وارد کنید",
    error_in_registration_operation: "عملیات ثبت نام در سرور منجر به خطا شد.",
    i_entered_the_email_incorrectly: "ایمیل را اشتباه وارد کردم",
    no_email_received_resend: "هیچ ایمیلی دریافت نشد، ارسال مجدد",
    referral_code: "کد معرف",
    referral_code_hint: "وارد کردن کد معرف، اختیاری است",
    sign_up: "ایجاد حساب کاربری جدید",
    successful_register_message: "ثبت نام شما با موفقیت انجام شد. با نام کاربری و رمز عبور خود وارد شوید.",
    user_info: "مشخصات کاربر",
    login_to_your_rebit_account: "به حساب کاربری‌تان وارد شوید",
    out_of_date_rebit_app: "نسخه قدیمی اپلیکیشن",
    you_are_successfully_registered: "حساب کاربری شما با موفقیت ایجاد شد!",
    i_forgot_my_password: "رمز عبورم را فراموش کرده‌ام",
    i_know_the_password_go_to_login: "رمز عبورم را می‌دانم، به صفحه ورود برو",
    not_sure_create_a_new_account: "مطمئن نیستم، یک حساب کاربری جدید ایجاد کن",
    select_your_country_of_residence: 'کشور محل سکونت خود را انتخاب کنید',
    errors: {
      poor_connection_refresh_and_try_again: "ارتباط ضعیف. لطفاً دوباره تلاش کنید!",
      email_already_taken: "این آدرس ایمیل قبلاً ثبت شده است!",
      invalid_recaptcha: "ریکپچا نامعتبر است!",
      it_may_be_due_to_your_internet_speed: "ممکن است این مشکل به خاطر سرعت اینترنت باشد. لطفاً مجدداً تلاش کنید!",
      check_your_email_and_use_the_verification_code: "ایمیلتان را جهت دریافت کد اعتبارسنجی چک کنید.",
      you_or_someone_else_has_created_an_unverified_account_with_this_email_already: "پیش از این، شما یا شخص دیگری از طریق این ایمیل یک حساب کاربری ایجاد کرده است. چه کار می‌کنید؟",
    },
  },

  forgot: {
    get_activation_code: "درخواست کد فعالسازی",
    hint: "اطلاعات زیر جهت بازیابی رمز عبور شما مورد نیاز است",
    errors: {
      invalid_email_address: "آدرس ایمیل نامعتبر",
      invalid_password: "رمز عبور نامعتبر"
    },
  },
  verify: {
      index: "تأیید",
      a_verification_code_sent_to_your_email: "کد اعتبارسنجی به ایمیل شما ارسال شد.",
      please_enter_it_here: "لطفاً کد را در اینجا وارد کنید",
      i_didnt_get_any_email_send_it_again: "من ایمیلی دریافت نکردم، دوباره ارسال شود!",
      change_password: "تغییر رمز عبور",
      invalid_password: "رمز عبور نامعتبر!",
      current_password: "رمز عبور کنونی",
      new_password: "رمز عبور جدید",
      new_password_confirmation: "تکرار رمز عبور جدید",
      password_confirmation_does_not_match: "رمز عبور‌ها تطابق ندارند.",
      password_has_been_changed_successfully: "رمز عبور با موفقیت تغییر کرد!",
      your_password_has_been_changed_successfully: "رمز عبور شما با موفقیت تغییر کرد!",
      you_should_logout_to_apply: "برای اعمال آن باید خارج شوید.",
      there_is_an_error_when_sending_email : "در ارسال ایمیل خطایی رخ داد.",
      please_refresh_the_page_and_try_again: "لطفاً صفحه را رفرش و مجدداً تلاش کنید."
  }
}

